class CountrySelector extends HTMLElement {
    constructor() {
        super();

        // 创建 shadow DOM
        const shadow = this.attachShadow({ mode: 'open' });

        // 插入样式和 HTML 模板
        shadow.innerHTML = `
            <div class="ug-country-selector"><slot></slot></div>
            <div class="ug-select-country-dialog">
    <div class="ug-select-country-dialog__main">
        <div class="ug-select-country-dialog__header">
            <div class="ug-select-country-dialog__header__title">Select Your Country/Region</div>
            <div class="ug-select-country-dialog__header__close">
                <a href="javascript:void(0)" class="ug-select-country-dialog__header__close__link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </a>
            </div>
        </div>
        <div class="ug-select-country-dialog__body">
            <ul class="ug-select-country-dialog__body__list">
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://www.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg class="earth-icon" aria-hidden="true">
								<use xlink:href="#icon-US_icon"></use>
							</svg>
                            <span>United States</span>
                            <span class="language">English</span>
                        </div>

                    </a>
                </li>
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://eu.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg class="earth-icon" aria-hidden="true">
								<use xlink:href="#icon-EU_icon"></use>
							</svg>
                            <span>Europe</span>
                            <span class="language">English</span>
                        </div>
                    </a>
                </li>
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://ca.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg class="earth-icon" aria-hidden="true">
								<use xlink:href="#icon-CA_icon"></use>
							</svg>
                            <span>Canada</span>
                            <span class="language">English</span>
                        </div>
                    </a>
                </li>
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://de.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg class="earth-icon" aria-hidden="true">
								<use xlink:href="#icon-DE_icon"></use>
							</svg>
                            <span>Deutschland</span>
                            <span class="language">Deutsch</span>
                        </div>
                    </a>
                </li>
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://uk.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg class="earth-icon" aria-hidden="true">
								<use xlink:href="#icon-UK_icon"></use>
							</svg>
                            <span>United Kingdom</span>
                            <span class="language">English</span>
                        </div>
                    </a>
                </li>
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://fr.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg class="earth-icon" aria-hidden="true">
								<use xlink:href="#icon-FR_icon"></use>
							</svg>
                            <span>France</span>
                            <span class="language">Français</span>
                        </div>
                    </a>
                </li>
                <li class="ug-select-country-dialog__body__list__item">
                    <a href="https://nl.ugreen.com?SkipCozyRedirect=yes" class="ug-select-country-dialog__body__list__item__link">
                        <div class="ug-select-country-dialog__body__list__item__link__name">
							<svg t="1704693223812" class="earth-icon" viewbox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4750" width="200" height="200"><path d="M22.26087 519.034435a489.73913 489.73913 0 1 0 979.47826 0 489.73913 489.73913 0 0 0-979.47826 0z" fill="#F0F0F0" p-id="4751"></path><path d="M512 29.250783c-210.587826 0-390.099478 132.941913-459.286261 319.443478h918.572522C902.010435 162.148174 722.543304 29.250783 512 29.250783z" fill="#D80027" p-id="4752"></path><path d="M512 1008.729043c210.587826 0 390.054957-132.897391 459.286261-319.398956H52.713739c69.186783 186.546087 248.698435 319.398957 459.286261 319.398956z" fill="#0052B4" p-id="4753"></path></svg>
                            <span>Nederland</span>
                            <span class="language">Nederlands</span>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
        `;

        // 添加事件监听器
        this.shadowRoot.querySelector('.ug-country-selector').addEventListener('click', () => {
            this.shadowRoot.querySelector('.ug-select-country-dialog').style.display = 'block';
        });

        this.shadowRoot.querySelector('.ug-select-country-dialog__header__close__link').addEventListener('click', () => {
            this.shadowRoot.querySelector('.ug-select-country-dialog').style.display = 'none';
        });

        // 初始化国家信息
        this.initCountry();
    }

    initCountry() {
        const COUNTRY = {
            eu: 'Europe / English',
            www: 'United States / English',
            ca: 'Canada / English',
            de: 'Deutschland / Deutsch',
            uk: 'United Kingdom / English',
            fr: 'France / Français',
            nl: 'Nederland / Nederlands',
        };

        const hostname = window.location.hostname;
        const country = hostname.split('.')[0];
        const currentCountry = COUNTRY[country] || 'United States / English';
        const text =  this.shadowRoot.querySelector('.ug-current-country-text')
        text.textContent = currentCountry;
        if(text){
            text.textContent = currentCountry;
        }
    }
}

// 注册自定义元素
// customElements.define('ug-country-selector', CountrySelector);
